import { DeviceRight } from "./device-right.model";
import { Entity } from "./entity.model";
import { Permission } from "./permission.model";
import { CompanyBase } from "./company.model";

export class ApiKey extends Entity {
  key: string;
  description: string;
  company?: CompanyBase;
  createdAt: Date;
  createdBy: string;
  updatedAt: Date;
  lastLogin: Date;
  updatedBy: string | null;
  active: boolean;
  permissions: Permission[];
  deviceRights: DeviceRight[];

  constructor({
    id,
    key,
    description,
    company,
    createdAt,
    createdBy,
    updatedAt,
    lastLogin,
    updatedBy,
    active,
    permissions,
    deviceRights,
  }: ApiKey) {
    super(id);
    this.key = key;
    this.description = description;
    this.company = company ? new CompanyBase(company) : undefined;
    this.createdAt = new Date(createdAt);
    this.createdBy = createdBy;
    this.updatedAt = new Date(updatedAt);
    this.lastLogin = lastLogin;
    this.updatedBy = updatedBy;
    this.active = active;
    this.permissions = permissions || [];
    this.deviceRights = deviceRights || [];
  }
}
